<template>
  <SDialog
    :show-dialog="showDialog"
    :width="450"
    :title="$t('ida.label.join')"
    @update:show-dialog="emits('update:showDialog', $event)"
    @close="emits('close')"
  >
    <VCardText class="px-6 pb-6 pt-2">
      <p class="font14 text-center mt-0 mb-4">
        {{ $t('ida.p.signUp') }}
      </p>

      <ObservedForm
        :loading="joinStore.loading"
        :error-messages="joinStore.error ? [joinStore.error] : []"
        data-testid="join-entry-form"
        @submit="onSubmit"
      >
        <VRow>
          <VCol cols="12">
            <TextFieldWithValidation
              v-model="email"
              :label="$t('label.email')"
              name="joinEmail"
              rules="required|email|max:75"
              data-testid="join-email"
              autocomplete="email"
              required
            />
          </VCol>
        </VRow>
        <VRow no-gutters>
          <VCol cols="12">
            <SBtn
              color="primary"
              action
              type="submit"
              block
              data-testid="join-get-started"
            >
              {{ $t('ida.btn.getStarted') }}
            </SBtn>
          </VCol>
        </VRow>
      </ObservedForm>
    </VCardText>
  </SDialog>
</template>

<script lang="ts" setup>
import ObservedForm from '~/components/base/ObservedForm.vue'
import TextFieldWithValidation from '~/components/base/fields/TextFieldWithValidation.vue'
import { useJoinStore } from '~/stores/join'

interface Props {
  showDialog: boolean
}

defineProps<Props>()

const emits = defineEmits<{
  (e: 'update:showDialog', show: boolean): void
  (e: 'close'): void
  (e: 'email-checked', result: { email: string }): void
}>()

const joinStore = useJoinStore()
const email = ref('')

const onSubmit = async () => {
  const result = await joinStore.checkEmail(email.value)
  if (result) {
    emits('email-checked', { email: email.value })
  }
}
</script>
